import { useState } from "react";

const useTextFilter = ({ data = [], id, label, shortLabel = true }) => {
  const [filterText, setFilterText] = useState("");

  const getFilteredData = (value) => {
    if (!Array.isArray(data)) return [];
    if (!value) return data;

    const idArray = Array.isArray(id) ? id : [id];

    return data.filter((item) =>
      idArray.some((key) =>
        item[key]?.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const onChange = ({ value }) => {
    setFilterText((state) => (state !== value ? value : state));
  };

  return {
    filteredData: getFilteredData(filterText),
    onChange,
    id: Array.isArray(id) ? id[0] : id,
    label,
    shortLabel,
  };
};

export default useTextFilter;
